<!-- horizontal -->
<div class="headlines">SeqCAT Toolbox</div>
<div class="content-overview">
    <div class="flip" routerLink="/converter/converter-dna-protein">
        <div class="front" style="background-color: darkcyan;">
            <div class="dna"></div>
            <h1 class="text-shadow">DNA TO PROTEIN CONVERSION</h1>
        </div>
        <div class="back">
            <h2>DNA TO PROTEIN CONVERSION</h2>
            <p>
                Convert your DNA substitutions into the associated protein exchange.
            </p>
        </div>
    </div>

    <div class="flip" routerLink="/converter/converter-liftover">
        <div class="front" style="background-color: goldenrod;">
            <div class="dna"></div>
            <h1 class="text-shadow">GENOMIC LIFTOVER</h1>
        </div>
        <div class="back">
            <h3>GENOMIC LIFTOVER</h3>
            <p>
                Convert you genomic coordinates from one genome assembly to another.
            </p>
        </div>
    </div>

    <div class="flip" routerLink="/converter/converter-protein-dna">
        <div class="front" style="background-color: darkmagenta;">
            <div class="protein"></div>
            <h1 class="text-shadow">PROTEIN TO DNA CONVERSION</h1>
        </div>
        <div class="back">
            <h2>PROTEIN TO DNA CONVERSION</h2>
            <p>
                Convert your Protein substitution into possible associated DNA exchanges.
            </p>
        </div>
    </div>

    <div class="flip" routerLink="/converter/converter-genome-to-protein-sequence">
        <div class="front" style="background-color: lightseagreen;">
            <div class="dna"></div>
            <h1 class="text-shadow">CONVERT DNA TO PROTEIN SEQUENCE</h1>
        </div>
        <div class="back">
            <h3>CONVERT DNA TO PROTEIN SEQUENCE</h3>
            <p>
                Convert a genomic sequence into its protein sequence.
            </p>
        </div>
    </div>

    <div class="flip" routerLink="/converter/converter-transcript-to-gene-genomic">
        <div class="front" style="background-color: deepskyblue;">
            <div class="dna"></div>
            <h1 class="text-shadow">TRANSCRIPT TO GENOMIC & GENE</h1>
        </div>
        <div class="back">
            <h3>TRANSCRIPT TO GENOMIC & GENE</h3>
            <p>
                Convert a trancript variant into its protein and genomic exchanges.
            </p>
        </div>
    </div>


    <div class="flip" routerLink="/converter/converter-transcript-to-geneid">
        <div class="front" style="background-color: mediumblue;">
            <div class="dna"></div>
            <h1 class="text-shadow">TRANSCRIPT TO HGNC IDENTIFIER</h1>
        </div>
        <div class="back">
            <h3>TRANSCRIPT TO HGNC IDENTIFIER</h3>
            <p>
                Convert a trancript into its HGNC identifier and HUGO gene name.
            </p>
        </div>
    </div>

    <div class="flip" routerLink="/converter/converter-gene-normalizer">
        <div class="front" style="background-color: darkolivegreen;">
            <div class="dna"></div>
            <h1 class="text-shadow">GENE NAME NORMALIZER</h1>
        </div>
        <div class="back">
            <h3>GENE NAME NORMALIZER</h3>
            <p>
                Map gene names to their approved symbols and get additional information.
            </p>
        </div>
    </div>

    <div class="flip" routerLink="/converter/converter-reverse-complement">
        <div class="front" style="background-color: indianred;">
            <div class="dna"></div>
            <h1 class="text-shadow">REVERSE COMPLEMENT</h1>
        </div>
        <div class="back">
            <h3>REVERSE COMPLEMENT</h3>
            <p>
                Convert a genomic sequence into its reverse complement, reverse or complementary sequence.
            </p>
        </div>
    </div>

    <div class="flip" routerLink="/converter/converter-transcript">
        <div class="front" style="background-color: darksalmon;">
            <div class="protein"></div>
            <h1 class="text-shadow">GET TRANSCRIPTS</h1>
        </div>
        <div class="back">
            <h2>GET TRANSCRIPTS</h2>
            <p>
                Get all available transcripts for a given HUGO gene name.
            </p>
        </div>
    </div>

    <div class="flip" routerLink="/converter/converter-exon-info">
        <div class="front" style="background-color: rgb(71, 165, 42);">
            <div class="protein"></div>
            <h1 class="text-shadow">EXON INFO<br></h1>
        </div>
        <div class="back">
            <h2>EXON INFO</h2>
            <p>
                Get all available exon information for a given HUGO gene name.
            </p>
        </div>
    </div>

    <div class="flip" routerLink="/converter/converter-protein-info">
        <div class="front" style="background-color: darkslateblue;">
            <div class="protein"></div>
            <h1 class="text-shadow">PROTEIN SEQUENCE</h1>
        </div>
        <div class="back">
            <h2>PROTEIN SEQUENCE</h2>
            <p>
                Get all available information for a given HUGO gene name and manipulate sequences by adding
                amino acid exchanges.
            </p>
        </div>
    </div>


    <div class="flip" routerLink="/converter/converter-fusion-check">
        <div class="front" style="background-color: chocolate;">
            <div class="dna"></div>
            <h1 class="text-shadow">FUSION CHECK</h1>
        </div>
        <div class="back">
            <h2>FUSION CHECK</h2>
            <p>
                Check wether a fusion event results into a frameshift in the evolved genes of the event.
            </p>
        </div>
    </div>

    <div class="flip" routerLink="/converter/converter-gene-in-kegg-pathway">
        <div class="front" style="background-color: darkslategrey;">
            <div class="protein"></div>
            <h1 class="text-shadow">PATHWAY VISUALIZER</h1>
        </div>
        <div class="back">
            <h2>PATHWAY VISUALIZER</h2>
            <p>
                Select a KEGG pathway, visualize it and see how genes inside interact with each other.
            </p>
        </div>
    </div>

    <div class="flip" routerLink="/converter/converter-dna-info">
        <div class="front" style="background-color: rgb(172, 5, 5);">
            <div class="dna"></div>
            <h1 class="text-shadow">DNA SEQUENCE</h1>
        </div>
        <div class="back">
            <h2>DNA SEQUENCE</h2>
            <p>
                Get sequence information for a given chromosome, start and end position.
            </p>
        </div>
    </div>
</div>


<div class="headlines">Info Points</div>
<div class="content-overview">

    <div class="flip" routerLink="/converter/converter-amino-info">
        <div class="front" style="background-color: #3E608C;">
            <div class="protein"></div>
            <h1 class="text-shadow">AMINO ACID INFOS</h1>
        </div>
        <div class="back">
            <h2>AMINO ACID INFOS</h2>
            <p>
                Get all available information for each amino acid, including abbreviations, properties and structure.
            </p>
        </div>
    </div>
    <div class="flip" routerLink="/converter/converter-aa-table">
        <div class="front" style="background-color: #994750;">
            <div class="aa-table"></div>
            <h1 class="text-shadow">AMINO ACID TABLE</h1>
        </div>
        <div class="back">
            <h2>AMINO ACID TABLE</h2>
            <p>
                Get all available information for each amino acid, including abbreviations, properties and structure.
            </p>
        </div>
    </div>

    <div class="flip" routerLink="/converter/converter-blossum-matrix">
        <div class="front" style="background-color: orchid;">
            <div class="protein"></div>
            <h1 class="text-shadow">BLOSSUM MATRIX</h1>
        </div>
        <div class="back">
            <h2>BLOSSUM MATRIX</h2>
            <p>
                Get all available information for the BLOSSUM substitution matrix.
            </p>
        </div>
    </div>
</div>